import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import SpendenlaufInfo from "@/pages/SpendenlaufInfo";
import AdminPage from "@/pages/AdminPage";
import Impressum from "@/pages/Impressum";
import Datenschutz from "@/pages/Datenschutz";
import AGB from "@/pages/AGB";
import FirmenanmeldungPage from "@/pages/FirmenanmeldungPage";
import EnglishPage from "@/pages/EnglishPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/spendenlauf" element={<SpendenlaufInfo />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
          <Route path="/agb" element={<AGB />} />
          <Route path="/firmenanmeldung" element={<FirmenanmeldungPage />} />
          <Route path="/en" element={<EnglishPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
